import {
    Button,
    Grid,
    Paper,
    TableContainer,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { Controller, useForm } from "react-hook-form";
  import { useDispatch } from "react-redux";
  import { useLocation, useNavigate } from "react-router-dom";
  import { toast } from "react-toastify";
  import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
  import LeftSideNav from "../../../Components/LeftSideNav";
  import TopNavBar from "../../../Components/TopNavbar";
  import Fonts from "../../../Config/Fonts";
  import Strings from "../../../Config/Strings";
  import { updatePageDetailsAPI } from "../../../Store/Action/page";
  import Colors from "../../../theme/Colors";
  import CustomButton from "../../../Components/CustomButton";
  
  const UpdatePage = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { editpage } = location.state || {};
    const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({ });
    
    const [breadcrumbs, setBreadcrumbs] = useState([]);
  
    useEffect(() => {
      setBreadcrumbs([
        { key: "1", href: "/userList", text: "Masters" },
        { key: "2", href: "/page", text: "Page" },
        { key: "3", href: "/page/edit", text: "Update Page" },
      ]);
    }, []);
  
    const onSubmit = async (data) => {
        
        const requestData = {
          page_id: editpage?.page_id,
          page_name: data.page_name,
          page_slug: data.page_slug,
          page_json: data.page_json,
          page_meta_title: data.page_meta_title,
          page_meta_description: data.page_meta_description,
          page_meta_keywords: data.page_meta_keywords,
          page_tags: data.page_tags,
          page_og_title: data.page_og_title,
          page_og_description: data.page_og_description,
          page_og_image: data.page_og_image,
          page_og_alt: data.page_og_alt,
        };
  
      try {
        await dispatch(
          updatePageDetailsAPI(requestData, (isSuccess, response) => {
            if (isSuccess?.status === true) {
              toast.success(response?.data?.message);
              navigate("/page");
            } else {
              const errorMessage =
                response?.error?.message || Strings.somethingWentWrongError;
              toast.error(errorMessage);
            }
          })
        );
      } catch (error) {
        console.log("Error dispatching updatePage:", error);
        toast.error(Strings.somethingWentWrongError);
      }
    };
  
    if (!editpage) {
      return <div>No page details available.</div>;
    }
  
    return (
      <div style={mainContainer}>
        <LeftSideNav />
        <div style={leftNavContainer}>
          <div style={topBar}>
            <TopNavBar />
            <div style={pageTitle}>
              <h2>Page</h2>
            </div>
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
          </div>
          <TableContainer component={Paper} style={tableContainer}>
            <p style={mainHeadingStyle}>Update Page</p>
            <hr />
            {/* <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page Name</Typography>
                <Controller
                  name="page_name"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page Name"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_name}
                      helperText={
                        errors?.page_name ? errors?.page_name.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page Slug</Typography>
                <Controller
                  name="page_slug"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page Slug"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_slug}
                      helperText={
                        errors?.page_slug ? errors?.page_slug.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page JSON</Typography>
                <Controller
                  name="page_json"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page JSON"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      error={!!errors?.page_json}
                      helperText={
                        errors?.page_json ? errors?.page_json.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page Meta Title</Typography>
                <Controller
                  name="page_meta_title"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page Meta Title"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_meta_title}
                      helperText={
                        errors?.page_meta_title ? errors?.page_meta_title.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page Meta Description</Typography>
                <Controller
                  name="page_meta_description"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page Meta Description"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      error={!!errors?.page_meta_description}
                      helperText={
                        errors?.page_meta_description ? errors?.page_meta_description.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page Meta Keywords</Typography>
                <Controller
                  name="page_meta_keywords"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page Meta Keywords"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_meta_keywords}
                      helperText={
                        errors?.page_meta_keywords ? errors?.page_meta_keywords.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page Tags</Typography>
                <Controller
                  name="page_tags"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page Tags"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_tags}
                      helperText={
                        errors?.page_tags ? errors?.page_tags.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page OG Title</Typography>
                <Controller
                  name="page_og_title"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page OG Title"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_title}
                      helperText={
                        errors?.page_og_title ? errors?.page_og_title.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page OG Description</Typography>
                <Controller
                  name="page_og_description"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page OG Description"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      error={!!errors?.page_og_description}
                      helperText={
                        errors?.page_og_description ? errors?.page_og_description.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page OG Image</Typography>
                <Controller
                  name="page_og_image"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page OG Image"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_image}
                      helperText={
                        errors?.page_og_image ? errors?.page_og_image.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page OG Alt</Typography>
                <Controller
                  name="page_og_alt"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page OG Alt"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_alt}
                      helperText={
                        errors?.page_og_alt ? errors?.page_og_alt.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <CustomButton handleSubmit={handleSubmit} label={Strings.Save} />
          </form> */}

<form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page Name</Typography>
                <Controller
                  name="page_name"
                  control={control}
                  defaultValue={editpage.page_name}
                  rules={{ required: Strings.pageNameRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page Name"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_name}
                      helperText={
                        errors?.page_name ? errors?.page_name.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page Slug</Typography>
                <Controller
                  name="page_slug"
                  control={control}
                  defaultValue={editpage.page_slug}
                  rules={{ required: Strings.pageSlugRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page Slug"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_slug}
                      helperText={
                        errors?.page_slug ? errors?.page_slug.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              {/* <Grid item xs={12} sm={6}>
      <Typography style={labelInfoStyle}>Page JSON</Typography>
      <Controller
        name="page_json"
        control={control}
        defaultValue=""
        rules={{ required: Strings.pageJsonRequired }}
        render={({ field }) => (
          <TextField
            {...field}
            placeholder="Enter Page JSON"
            variant="outlined"
            fullWidth
            error={!!errors?.page_json}
            helperText={errors?.page_json ? errors?.page_json.message : ""}
            InputProps={{
              style: inputTextStyle,
            }}
          />
        )}
      />
    </Grid> */}
              <Grid item xs={12}>
                <Typography style={labelInfoStyle}>Page JSON</Typography>
                <Controller
                  name="page_json"
                  control={control}
                  defaultValue={editpage.page_json}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Page JSON"
                      variant="outlined"
                      fullWidth
                      multiline
                      rows={4}
                      error={!!errors?.page_json}
                      helperText={
                        errors?.page_json ? errors?.page_json.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page Meta Title</Typography>
                <Controller
                  name="page_meta_title"
                  control={control}
                  defaultValue={editpage.page_meta_title}
                  rules={{ required: Strings.pageMetaTitleRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page Meta Title"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_meta_title}
                      helperText={
                        errors?.page_meta_title
                          ? errors?.page_meta_title.message
                          : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>
                  Page Meta Description
                </Typography>
                <Controller
                  name="page_meta_description"
                  control={control}
                  defaultValue={editpage.page_meta_description}
                  rules={{ required: Strings.pageMetaDescriptionRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page Meta Description"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_meta_description}
                      helperText={
                        errors?.page_meta_description
                          ? errors?.page_meta_description.message
                          : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>
                  Page Meta Keywords
                </Typography>
                <Controller
                  name="page_meta_keywords"
                  control={control}
                  defaultValue={editpage.page_meta_keywords}
                  rules={{ required: Strings.pageMetaKeywordsRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page Meta Keywords"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_meta_keywords}
                      helperText={
                        errors?.page_meta_keywords
                          ? errors?.page_meta_keywords.message
                          : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page Tags</Typography>
                <Controller
                  name="page_tags"
                  control={control}
                  defaultValue={editpage.page_tags}
                  rules={{ required: Strings.pageTagsRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page Tags"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_tags}
                      helperText={
                        errors?.page_tags ? errors?.page_tags.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page OG Title</Typography>
                <Controller
                  name="page_og_title"
                  control={control}
                  defaultValue={editpage.page_og_title}
                  rules={{ required: Strings.pageOgTitleRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page OG Title"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_title}
                      helperText={
                        errors?.page_og_title
                          ? errors?.page_og_title.message
                          : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>
                  Page OG Description
                </Typography>
                <Controller
                  name="page_og_description"
                  control={control}
                  defaultValue={editpage.page_og_description}
                  rules={{ required: Strings.pageOgDescriptionRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page OG Description"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_description}
                      helperText={
                        errors?.page_og_description
                          ? errors?.page_og_description.message
                          : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page OG Image</Typography>
                <Controller
                  name="page_og_image"
                  control={control}
                  defaultValue={editpage.page_og_image}
                  rules={{ required: Strings.pageOgImageRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page OG Image URL"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_image}
                      helperText={
                        errors?.page_og_image
                          ? errors?.page_og_image.message
                          : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography style={labelInfoStyle}>Page OG Alt</Typography>
                <Controller
                  name="page_og_alt"
                  control={control}
                  defaultValue={editpage.page_og_alt}
                  rules={{ required: Strings.pageOgAltRequired }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter Page OG Alt Text"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.page_og_alt}
                      helperText={
                        errors?.page_og_alt ? errors?.page_og_alt.message : ""
                      }
                      InputProps={{
                        style: inputTextStyle,
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <CustomButton
                  handleSubmit={handleSubmit}
                  label={Strings.Save}
                />
              </Grid>
            </Grid>
          </form>
          </TableContainer>
        </div>
      </div>
    );
  };
  
  const mainContainer = {
    display: "grid",
    gridTemplateColumns: "20% 80%",
    height: "100vh",
    width: "100vw",
    overflowX: "hidden",
    overflowY: "hidden",
  };
  
  const leftNavContainer = {
    display: "grid",
    gridTemplateRows: "15% 80%",
    backgroundColor: "#F0F5FF",
  };
  
  const topBar = {
    backgroundColor: "white",
    height: "7vh",
    width: "100%",
  };
  
  const pageTitle = {
    marginLeft: "30px",
    justifyContent: "flex-start",
    display: "flex",
  };
  
  const tableContainer = {
    width: "70vw",
    border: "1px solid #ccc",
    borderRadius: "15px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    marginTop: "40px",
    paddingLeft: "20px",
    paddingRight: "20px",
    marginLeft: "30px",
  };
  
  const formStyle = {
    padding: "20px",
  };
  
  const mainHeadingStyle = {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: Fonts.NunitoSans,
    color: Colors.black,
    display: "flex",
    marginTop: '20px',
    marginBottom: '20px'
  };
  
  const labelInfoStyle = {
    fontSize: 14,
    fontWeight: "400",
    fontFamily: Fonts.NunitoSans,
    color: Colors.black,
    display: "flex",
    marginBottom: "5px",
  };
  
  const inputTextStyle = {
    fontSize: 14,
    fontWeight: "400",
    fontFamily: Fonts.NunitoSans,
    color: Colors.darkGray,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    backgroundColor: Colors.lightBlue,
  };
  
  export default UpdatePage;
  